module.exports = __webpack_public_path__ + "img/26.b77752d6.jpg";